import { z } from 'zod';
/**
 * Envelope and pagination contracts shared by the Admin REST API and the
 * Partner REST API. The Storefront GraphQL API has its own error shape.
 */
/** Machine-readable error codes. The client switches on these, not on prose. */
export const API_ERROR_CODES = [
    'BAD_REQUEST',
    'VALIDATION_FAILED',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'TENANT_NOT_RESOLVED',
    'NOT_FOUND',
    'CONFLICT',
    'RATE_LIMITED',
    /**
     * The payment provider declined. Distinct from CONFLICT because the client
     * response differs: a decline means "try another card", not "reload".
     */
    'PAYMENT_FAILED',
    'INTERNAL_ERROR',
];
/**
 * Cursor pagination, not offset. Catalogues and order lists are written to
 * constantly, and OFFSET both skips rows that shift under the reader and
 * degrades linearly on deep pages.
 */
export const cursorPageQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(250).default(50),
});
//# sourceMappingURL=api.js.map